import DefaultButton from "../default.button";
import { ReactComponent as UploadIcon } from "../../../assets/icons/upload.icon.svg";
import { useRef } from "react";
import useXlsxToJson from "../../../hooks/files/useXlsxToJson.file.hook";
import { useContext } from "react";
import { ProductsContext } from "../../../contexts/products/products.context";

const UploadProductsButton = () => {
  const { createProducts } = useContext(ProductsContext);
  const { xlsxToJson } = useXlsxToJson();
  // Create ref for the file input
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const SKIP = 2; // +1 for 0-based index, +1 for header row
    if (file) {
      try {
        const json = await xlsxToJson(file);
        const errorLog = [];
        console.log(json);
        json.filter((product, index) => {
          let isValid = true;
          if (!product.Make) {
            errorLog.push(`Make is required: ${index + SKIP}`);
            isValid = false;
          }
          if (!product.Model) {
            errorLog.push(`Model is required: ${index + SKIP}`);
            isValid = false;
          }
          if (!product.Category) {
            errorLog.push(`Category is required: ${index + SKIP}`);
            isValid = false;
          }
          if (product?.Price) {
            if (isNaN(product?.Price)) {
              errorLog.push(`Price must be a number: ${index + SKIP}`);
              isValid = false;
            }
          }
          if (product?.["RepairShopr ID (Not Required)"]) {
            if (isNaN(product["RepairShopr ID (Not Required)"])) {
              errorLog.push(`RepairShopr ID must be a number: ${index + 1}`);
              isValid = false;
            }
          }
          return isValid;
        });
        if (errorLog.length > 0) {
          alert(errorLog.join("\n"));
          return;
        }
        const products = json.map((product) => ({
          repairShopr_id: product?.["RepairShopr ID (Not Required)"],
          category: product.Category.trim(),
          make: product.Make.trim(),
          model: product.Model.trim(),
          external_description: product["External Description"].trim(),
          retail_price: product.Price
            ? (+product.Price).toFixed(2).toString()
            : undefined,
        }));
        console.log({ products });
        createProducts(products);
      } catch (error) {
        console.error(error);
        alert(`Failed to read file: ${error}`);
      }
    }
  };
  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // Accept only .xlsx files
      />
      <DefaultButton handleClick={handleButtonClick}>
        <UploadIcon className="fill-white" />
        Upload
      </DefaultButton>
    </>
  );
};

export default UploadProductsButton;
